<script setup>
    import { ref, onMounted, onBeforeUnmount } from 'vue';

    const { showConfirm } = useMessageBox();
    const currentVersion = ref(null);
    let checkVersionInterval = null;

    const checkVersion = async () => {
        try {
            const response = await fetch('/version.json?_t=' + Date.now());
            const data = await response.json();

            if (!currentVersion.value) {
                currentVersion.value = data.version;
            } else if (currentVersion.value !== data.version) {
                showConfirm("Hệ thống đã có phiên bản mới. Hãy tải lại trang để cập nhật. Bạn có muốn tải lại trang ngay không?").then((result) => {
                    if (result) {
                        window.location.reload();
                    }
                });
            }
        } catch (error) {
            console.error('Error checking version:', error);
        }
    };

    onMounted(() => {
        checkVersion();
        checkVersionInterval = setInterval(checkVersion, 60000); // mỗi 1 phút check lại
    });

    onBeforeUnmount(() => {
        if (checkVersionInterval) {
            clearInterval(checkVersionInterval);
        }
    });
</script>
